import React from "react";
import { Check } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import { songPriceLabel } from "@/utils/price";
import { useIsAndroidApp } from "@/hooks/useLaunchContext";
import { WIZARD } from "@/constants/testIds";

const LABELS = {
  versions_fee: "wizard.versionsLabel",
  lyrics_fee: "pricing.lyricsAi",
  voice_fee: "pricing.voice",
  vocal_style_fee: "pricing.vocalStylePremium",
  thumbnail_fee: "pricing.thumbnail",
  title_fee: "pricing.customTitle",
  message_fee: "pricing.message",
  gift_fee: "pricing.gift",
  youtube_fee: "pricing.youtube",
  download_fee: "pricing.download",
  rush_fee: "pricing.rush",
  bonus_instrumental_fee: "pricing.bonusInstrumental",
  social_short_fee: "wizard.socialShortLabel",
  translation_fee: "wizard.translateLabel",
  certificate_fee: "wizard.certificateLabel",
  voice_message_fee: "wizard.voiceMessageLabel",
};

export default function PriceSidebar({ form, pricing }) {
  const { t, language } = useI18n();
  const isTwaApp = useIsAndroidApp();
  if (!pricing) return null;

  const selected = Object.entries(LABELS).filter(([key]) => pricing[key]);

  return (
    <div className="sticky top-24 rounded-2xl border border-border bg-card p-6" data-testid={WIZARD.priceCalculator}>
      <h3 className="font-heading text-lg font-medium">{t("wizard.summaryTitle")}</h3>

      <div className="mt-4 space-y-2 text-sm">
        <div className="flex items-center gap-2 text-muted-foreground">
          <Check className="h-3.5 w-3.5 shrink-0 text-primary" />
          <span>{t(`pricing.duration${form.duration_minutes}`)}</span>
        </div>
        {selected.map(([key, labelKey]) => (
          <div key={key} className="flex items-center gap-2 text-muted-foreground">
            <Check className="h-3.5 w-3.5 shrink-0 text-primary" />
            <span>{t(labelKey)}</span>
          </div>
        ))}
      </div>

      <div className="mt-4 border-t border-border pt-4">
        <p className="text-xs text-muted-foreground">{t("wizard.allIncluded")}</p>
        {!isTwaApp && (
          <div className="mt-1 flex items-center justify-between">
            <span className="font-heading text-base font-semibold">{t("wizard.priceTotal")}</span>
            <span className="font-heading text-2xl font-semibold text-primary" data-testid={WIZARD.priceTotal}>
              {songPriceLabel(language)}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
